import { doc, updateDoc } from "firebase/firestore";
import { db } from "@freetech/models/db";
import { Client } from "@freetech/models/projects";


export const updateClient = async (clientId: string, updatedClient: Partial<Client>): Promise<void> => {
  const clientRef = doc(db.clients, clientId);
  await updateDoc(clientRef, updatedClient);
}; 